module.exports = __webpack_public_path__ + "fd4bfe843467c2a150fd19873cd924cc.pdf";